// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Industrialtransportcompanyinpune() {



const cardData = {


    keyword: "Industrial Transport Company in Pune",

    headingDescription: "SSK Logistic provides organized industrial transport solutions in Pune for manufacturers, factories, engineering companies, warehouses, suppliers, and businesses handling heavy or specialized cargo. Industrial transportation may involve machinery, production equipment, raw materials, factory goods, containers, ODC consignments, full truck loads, and other large shipments that require suitable vehicle capacity and careful route planning. SSK Logistic coordinates transportation according to cargo weight, dimensions, loading conditions, pickup location, destination, and delivery requirements, supporting industrial businesses with practical road transportation across Pune, Maharashtra, and interstate manufacturing corridors.",

    topPlaces: [
        {
            title: "Chinchwad",
            description: "Chinchwad is an established industrial and manufacturing area with regular movement of machinery, engineering components, factory materials, and finished products. SSK Logistic coordinates industrial cargo transportation from and around Chinchwad according to shipment dimensions, vehicle requirements, loading conditions, and delivery destinations."
        },
        {
            title: "Pune to Surat",
            description: "Pune to Surat is an important interstate industrial corridor connecting manufacturing and commercial markets in Maharashtra and Gujarat. SSK Logistic supports transportation of machinery, factory materials, components, commercial inventory, and larger industrial consignments along this route."
        },
        {
            title: "Moshi",
            description: "Moshi has expanding industrial, warehousing, and commercial activity around the Pune region. SSK Logistic assists businesses in moving equipment, factory supplies, machinery, raw materials, and finished goods from this area through suitable road transportation arrangements."
        },
        {
            title: "Pune to Bhopal",
            description: "Pune to Bhopal provides a useful interstate connection for industrial and commercial businesses moving goods toward central India. SSK Logistic coordinates road transportation for machinery, equipment, industrial materials, factory products, and larger freight consignments."
        },
        {
            title: "Pirangut",
            description: "Pirangut is associated with manufacturing and industrial operations around the western side of Pune. SSK Logistic supports businesses transporting machinery, production materials, equipment, components, and finished factory goods between Pirangut and other industrial destinations."
        },
        {
            title: "Pune to Visakhapatnam",
            description: "Pune to Visakhapatnam is a long-distance industrial route connecting western India with an important eastern coastal business and manufacturing market. SSK Logistic supports movement of industrial equipment, machinery, commercial cargo, materials, and larger consignments requiring interstate road transportation."
        },
        {
            title: "Baramati",
            description: "Baramati has a diverse industrial and manufacturing base with requirements for movement of raw materials, equipment, components, machinery, and finished products. SSK Logistic coordinates transportation between Pune and Baramati according to cargo characteristics and vehicle capacity."
        },
        {
            title: "Pune to Rajahmundry",
            description: "Pune to Rajahmundry connects industrial and commercial businesses across western and southern India. SSK Logistic coordinates transportation for machinery, factory supplies, equipment, commercial goods, and industrial freight requiring longer-distance road movement."
        },
        {
            title: "Shikrapur",
            description: "Shikrapur is connected with industrial and warehouse activity along important Pune-region transportation corridors. SSK Logistic supports movement of factory goods, machinery, production materials, components, and commercial cargo with suitable vehicle and route planning."
        },
        {
            title: "Pune to Udaipur",
            description: "Pune to Udaipur is an interstate route useful for companies distributing industrial and commercial goods toward Rajasthan. SSK Logistic coordinates transportation of machinery, equipment, factory materials, packaged products, and larger business consignments according to route and vehicle requirements."
        }
    ],

    "services": [
        {
            "name": "industrial transport company pune",
            "description": "SSK Logistic supports businesses searching for an industrial transport company pune for movement of machinery, equipment, raw materials, factory goods, components, and finished products. Transportation arrangements are coordinated according to cargo weight, dimensions, vehicle capacity, route distance, and delivery requirements."
        },
        {
            "name": "industrial transportation pune",
            "description": "Industrial transportation pune requirements can involve regular factory dispatches, machinery movement, warehouse transfers, and interstate cargo transportation. SSK Logistic coordinates suitable road vehicles according to shipment type, cargo volume, loading conditions, and destination."
        },
        {
            "name": "industrial transport services pune",
            "description": "SSK Logistic provides industrial transport services pune for manufacturing units, factories, engineering businesses, warehouses, and industrial suppliers. Transportation can be arranged for machinery, components, production materials, equipment, and finished industrial goods across local and interstate routes."
        },
        {
            "name": "industrial goods transport pune",
            "description": "Industrial goods transport pune supports businesses moving raw materials, machinery components, finished products, tools, equipment, and factory supplies. SSK Logistic coordinates suitable transportation based on cargo characteristics, shipment size, loading requirements, and delivery destination."
        },
        {
            "name": "industrial logistics company pune",
            "description": "Businesses looking for an industrial logistics company pune can coordinate transportation requirements with SSK Logistic for machinery, factory goods, industrial materials, and larger consignments. Route planning, vehicle selection, pickup coordination, and delivery arrangements can be structured around the shipment."
        },
        {
            "name": "industrial cargo transport pune",
            "description": "Industrial cargo transport pune requires practical planning for different cargo weights, dimensions, and loading requirements. SSK Logistic coordinates road transportation for factory materials, equipment, machinery, components, and commercial industrial shipments."
        },
        {
            "name": "industrial freight transport pune",
            "description": "Industrial freight transport pune from SSK Logistic supports manufacturers and industrial businesses moving larger consignments between factories, suppliers, warehouses, and commercial destinations. Transportation arrangements can cover local Maharashtra movement as well as longer interstate freight routes."
        },
        {
            "name": "heavy transport company pune",
            "description": "A heavy transport company pune requirement often involves machinery, equipment, industrial materials, and substantial commercial cargo. SSK Logistic coordinates suitable transportation by considering shipment weight, dimensions, vehicle capacity, loading arrangements, route conditions, and destination access."
        },
        {
            "name": "heavy cargo transportation pune",
            "description": "Heavy cargo transportation pune requires careful vehicle selection and route planning for substantial industrial shipments. SSK Logistic supports movement of large equipment, machinery, production units, heavy materials, and other cargo requiring suitable transportation capacity."
        },
        {
            "name": "machinery transport pune",
            "description": "Machinery transport pune supports factories, manufacturers, engineering companies, and industrial facilities moving production machines and equipment. SSK Logistic coordinates road transportation according to machinery dimensions, weight, loading requirements, route distance, and destination conditions."
        },
        {
            "name": "equipment transportation pune",
            "description": "Equipment transportation pune can involve industrial tools, production equipment, engineering units, factory systems, and large commercial equipment. SSK Logistic helps coordinate suitable vehicles and transportation arrangements based on equipment size, weight, loading method, and delivery location."
        },
        {
            "name": "factory transportation services pune",
            "description": "Factory transportation services pune support manufacturers moving raw materials, production components, machinery, equipment, packaging supplies, and finished goods. SSK Logistic coordinates road transportation between factories, warehouses, suppliers, and customers according to operational requirements."
        },
        {
            "name": "manufacturing transport company pune",
            "description": "SSK Logistic supports businesses requiring a manufacturing transport company pune for movement of production materials, machinery, components, equipment, and finished products. Transportation planning can be adapted to factory schedules, cargo volume, vehicle capacity, and destination requirements."
        },
        {
            "name": "ODC transport company pune",
            "description": "An ODC transport company pune requirement involves specialized handling of consignments that exceed standard dimensions or have unusual cargo configurations. SSK Logistic coordinates transportation by considering measurements, weight, vehicle suitability, loading arrangements, route conditions, and destination access."
        },
        {
            "name": "full truck load industrial transport pune",
            "description": "Full truck load industrial transport pune is suitable for factories and manufacturers requiring dedicated vehicle capacity for larger shipments. SSK Logistic coordinates FTL movement for machinery, bulk materials, factory inventory, equipment, components, and finished industrial goods."
        },
        {
            "name": "container transport for industries pune",
            "description": "Container transport for industries pune supports businesses moving larger containerized cargo between factories, warehouses, suppliers, and distribution locations. SSK Logistic coordinates appropriate road transportation according to container requirements, cargo type, route distance, and delivery conditions."
        },
        {
            "name": "specialized industrial transport pune",
            "description": "Specialized industrial transport pune is useful for machinery, oversized equipment, heavy components, and cargo with specific transportation requirements. SSK Logistic coordinates suitable arrangements by considering cargo dimensions, weight, loading method, vehicle capacity, route, and destination."
        },
        {
            "name": "industrial goods transportation company",
            "description": "An industrial goods transportation company supports businesses moving factory materials, machinery, components, equipment, and finished goods between different operational locations. SSK Logistic coordinates road transportation according to cargo volume, vehicle requirements, route distance, and delivery schedule."
        },
        {
            "name": "reliable industrial transport pune",
            "description": "Businesses requiring reliable industrial transport pune can coordinate recurring and one-time shipments with SSK Logistic. Transportation arrangements support movement of machinery, factory goods, raw materials, equipment, components, and industrial inventory across suitable routes."
        },
        {
            "name": "safe industrial transportation pune",
            "description": "Safe industrial transportation pune requires appropriate vehicle selection, careful loading coordination, route planning, and suitable handling of industrial cargo. SSK Logistic structures transportation according to shipment weight, dimensions, cargo type, pickup conditions, and destination requirements."
        },
        {
            "name": "industrial logistics provider pune",
            "description": "SSK Logistic supports businesses looking for an industrial logistics provider pune for coordinated movement of machinery, factory materials, equipment, components, and finished products. Transportation planning can cover pickup, vehicle allocation, route coordination, and destination delivery requirements."
        },
        {
            "name": "industrial freight services pune",
            "description": "Industrial freight services pune from SSK Logistic help manufacturers and industrial suppliers move larger consignments between factories, warehouses, suppliers, and commercial destinations. Freight arrangements can be planned around shipment size, vehicle capacity, route distance, and cargo characteristics."
        },
        {
            "name": "industrial transport solutions pune",
            "description": "Industrial transport solutions pune can be coordinated for businesses with different cargo sizes, vehicle requirements, and route distances. SSK Logistic supports regular factory transportation as well as heavy machinery, specialized cargo, full truck loads, and interstate industrial freight."
        },
        {
            "name": "commercial industrial transport pune",
            "description": "Commercial industrial transport pune supports companies moving machinery, raw materials, factory inventory, equipment, components, and finished products between commercial and industrial locations. SSK Logistic coordinates suitable road vehicles according to shipment requirements and destination."
        },
        {
            "name": "industrial cargo logistics pune",
            "description": "Industrial cargo logistics pune requires coordination of cargo details, vehicle capacity, pickup arrangements, route planning, and delivery requirements. SSK Logistic supports businesses with organized road movement for industrial materials, machinery, equipment, factory goods, and larger commercial consignments."
        }
    ],

    "tableData": [
        ["industrial transport company pune", "industrial transportation pune"],
        ["industrial transport services pune", "industrial goods transport pune"],
        ["industrial logistics company pune", "industrial cargo transport pune"],
        ["industrial freight transport pune", "heavy transport company pune"],
        ["heavy cargo transportation pune", "machinery transport pune"],
        ["equipment transportation pune", "factory transportation services pune"],
        ["manufacturing transport company pune", "ODC transport company pune"],
        ["full truck load industrial transport pune", "container transport for industries pune"],
        ["specialized industrial transport pune", "industrial goods transportation company"],
        ["reliable industrial transport pune", "safe industrial transportation pune"],
        ["industrial logistics provider pune", "industrial freight services pune"],
        ["industrial transport solutions pune", "commercial industrial transport pune"],
        ["industrial cargo logistics pune", "Industrial Transport Company in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Industrial Cargo-Focused Transportation",
            WhyChoosedescription: "SSK Logistic coordinates transportation for manufacturers, factories, engineering businesses, and industrial suppliers handling machinery, raw materials, equipment, components, and finished products. Vehicle arrangements can be selected according to the specific characteristics of the cargo."
        },
        {
            WhyChooseheading: "Support for Heavy Shipments",
            WhyChoosedescription: "Heavy machinery and substantial industrial consignments require attention to weight, dimensions, loading methods, and vehicle capacity. SSK Logistic helps coordinate suitable road transportation for large equipment, factory machinery, heavy materials, and oversized commercial cargo."
        },
        {
            WhyChooseheading: "ODC Transportation Coordination",
            WhyChoosedescription: "Oversized consignments can have different transportation requirements compared with standard goods. SSK Logistic supports ODC movement by considering cargo measurements, weight, suitable vehicle configuration, loading requirements, route conditions, and destination accessibility."
        },
        {
            WhyChooseheading: "Manufacturing Area Connectivity",
            WhyChoosedescription: "Pune has a wide network of manufacturing and industrial locations around Pimpri-Chinchwad, Chakan, Ranjangaon, Talegaon, Pirangut, Baramati, and other areas. SSK Logistic supports transportation between these industrial zones and wider business markets."
        },
        {
            WhyChooseheading: "Full Truck Load Options",
            WhyChoosedescription: "Businesses with large industrial consignments may need dedicated truck capacity for efficient movement. SSK Logistic coordinates full truck load transportation for factory inventory, machinery, equipment, production materials, components, and finished goods."
        },
        {
            WhyChooseheading: "Interstate Industrial Routes",
            WhyChoosedescription: "Industrial supply chains frequently extend beyond Maharashtra into other manufacturing and commercial markets. SSK Logistic supports road transportation from Pune toward Gujarat, Madhya Pradesh, Rajasthan, Karnataka, Telangana, Andhra Pradesh, Tamil Nadu, and other destinations."
        },
        {
            WhyChooseheading: "Practical Vehicle Selection",
            WhyChoosedescription: "Vehicle suitability is an important part of industrial cargo transportation. SSK Logistic considers shipment quantity, weight, dimensions, loading requirements, route distance, and destination conditions while coordinating transportation for different types of industrial goods."
        },
        {
            WhyChooseheading: "Suitable for Recurring Factory Movement",
            WhyChoosedescription: "Manufacturing businesses may require repeated transportation for raw materials, components, machinery, finished goods, and warehouse transfers. SSK Logistic supports both recurring and individual industrial shipments with transportation planning based on each movement's operational requirements."
        }
    ]

};

















const faqData = [
    {
        question: "What industrial transportation services does SSK Logistic provide in Pune?",
        answer: "SSK Logistic assists industrial businesses with transportation of machinery, equipment, raw materials, finished products, production supplies, commercial stock, and other suitable industrial consignments from Pune to different destinations."
    },
    {
        question: "Can SSK Logistic transport industrial goods from Pune to other cities?",
        answer: "Industrial cargo movement can be arranged from Pune to destinations such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and other locations depending on the shipment requirements."
    },
    {
        question: "What industrial cargo can be transported through SSK Logistic?",
        answer: "Suitable industrial shipments may include machinery, equipment, raw materials, components, production materials, finished goods, industrial supplies, commercial inventory, and other cargo based on size, weight, and handling requirements."
    },
    {
        question: "Does SSK Logistic provide transportation for regular industrial shipments?",
        answer: "Industrial companies with recurring movement requirements can discuss regular transportation arrangements based on their shipment frequency, routes, cargo volume, vehicle capacity, pickup schedule, and expected delivery timelines."
    },
    {
        question: "How does SSK Logistic select vehicles for industrial transportation?",
        answer: "The vehicle requirement is planned by considering the cargo weight, dimensions, quantity, volume, loading conditions, material characteristics, route distance, destination, and specific transportation needs."
    },
    {
        question: "Can SSK Logistic provide industrial transportation from Pune to Mumbai?",
        answer: "Yes, businesses can arrange transportation of industrial materials, machinery, equipment, production supplies, commercial stock, and other suitable cargo between Pune and Mumbai according to the shipment details."
    },
    {
        question: "Does SSK Logistic handle interstate industrial goods transportation?",
        answer: "Interstate industrial transportation can be coordinated from Pune toward Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other regions according to route and cargo requirements."
    },
    {
        question: "Can manufacturing units in Pune use SSK Logistic for goods movement?",
        answer: "Manufacturing units can use transportation support for moving raw materials, finished products, machinery, equipment, production supplies, and inventory between factories, warehouses, suppliers, and other business locations."
    },
    {
        question: "Can industrial transportation be planned for specific company requirements?",
        answer: "Yes, transportation arrangements can be customized around the pickup location, destination, cargo specifications, weight, dimensions, loading requirements, vehicle capacity, delivery schedule, and frequency of industrial movement."
    },
    {
        question: "What details are required to arrange industrial transportation with SSK Logistic?",
        answer: "A company can provide its pickup location, delivery destination, material type, approximate weight and dimensions, quantity, loading requirements, vehicle preference, and expected delivery schedule to discuss an appropriate transportation solution."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Pranav Kulkarni",
        feedback: "Our manufacturing business required machinery transportation from Pune to Ahmedabad. SSK Logistic reviewed the cargo details and coordinated the vehicle arrangement according to the requirements of the shipment.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Mitali Jadhav",
        feedback: "We needed regular movement of industrial supplies from our Pune facility. SSK Logistic was easy to coordinate with, and the transportation planning was handled according to our shipment quantity and route.",
        rating: 5
    }
];













    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Industrial Transport Company in Pune",
  "image": "https://ssklogistics.in/assets/images/industrial-transport-company-in-pune.webp",
  "description": "SSK Logistics is an Industrial Transport Company in Pune supporting manufacturers, factories, engineering businesses, warehouses, distributors and industrial enterprises with organized transportation for goods, machinery, equipment and commercial cargo. Industrial transport company Pune requirements can involve regular movement of raw materials, finished products, machinery, production equipment and other industrial consignments between factories, warehouses, suppliers, project sites and business destinations. Industrial transportation Pune solutions can be coordinated according to cargo dimensions, load capacity, route distance and delivery schedules, while industrial transport services Pune support both local and interstate movement. Industrial goods transport Pune can cover manufacturing materials, packaged industrial products, components and heavy commercial consignments. As an industrial logistics company Pune, SSK Logistics assists businesses with transportation coordination, vehicle arrangements, shipment planning and route management. Industrial cargo transport Pune and industrial freight transport Pune can be arranged for different commercial load requirements, including recurring shipments and project-based transportation. Heavy transport company Pune requirements may involve the movement of bulky or high-weight cargo, while heavy cargo transportation Pune requires suitable vehicle selection and practical route planning. Machinery transport Pune and equipment transportation Pune can support factories, engineering companies and industrial projects moving valuable business assets between locations. Factory transportation services can also include regular material transfers, warehouse-to-factory movement, factory-to-customer deliveries and other industrial supply chain requirements. SSK Logistics focuses on flexible transportation coordination designed around the specific needs of industrial businesses.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/industrial-transport-company-in-pune"
  }
};



    return (
        <div>

<Helmet>
  <title>
    Industrial Transport Company in Pune | Heavy Cargo, Machinery & Equipment Transportation | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides industrial transport services in Pune for goods, freight, heavy cargo, machinery, equipment and factory transportation with coordinated vehicle and route planning."
  />

  <meta
    name="keywords"
    content="Industrial Transport Company in Pune, industrial transport company Pune, industrial transportation Pune, industrial transport services Pune, industrial goods transport Pune, industrial logistics company Pune, industrial cargo transport Pune, industrial freight transport Pune, heavy transport company Pune, heavy cargo transportation Pune, machinery transport Pune, equipment transportation Pune, factory transportation services, industrial transport company in Pune, industrial transportation services Pune, industrial goods transportation Pune, industrial logistics services Pune, industrial cargo transportation Pune, industrial freight transportation Pune, heavy goods transport Pune, heavy equipment transportation Pune, heavy machinery transport Pune, machinery transportation services Pune, equipment transport services Pune, factory goods transportation Pune, factory goods transport Pune, manufacturing transport services Pune, manufacturing goods transportation Pune, industrial material transport Pune, industrial material transportation Pune, commercial industrial transport Pune, project cargo transportation Pune, project transport services Pune, warehouse to factory transport Pune, factory to warehouse transport Pune, industrial supply chain transportation Pune, interstate industrial transport Pune, Maharashtra industrial transportation Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Industrialtransportcompanyinpune;